import { Break, BreakHistoryCompanyDto, BreakHistoryUserDto, StartBreakDto } from "../../types/break.types";
import apiService from "../api/api.service";

class BreakService {
  private static instance: BreakService;

  private constructor() {}

  public static getInstance(): BreakService {
    if (!BreakService.instance) {
      BreakService.instance = new BreakService();
    }
    return BreakService.instance;
  }

  public async startBreak(dto: StartBreakDto): Promise<Break> {
    const response = await apiService.post<Break>("/break/start", dto);
    return response;
  }

  public async endBreak(): Promise<Break> {
    const response = await apiService.post<Break>("/break/end");
    return response;
  }

  public async getBreakHistoryCompany(startDate: string, endDate: string): Promise<BreakHistoryCompanyDto[]> {
    const response = await apiService.get<BreakHistoryCompanyDto[]>(`/break/company?startDate=${startDate}&endDate=${endDate}`);
    return response;
  }

  public async getBreakHistoryUser(startDate: string, endDate: string,userId?: number): Promise<BreakHistoryUserDto[]> {
    const response = await apiService.get<BreakHistoryUserDto[]>(`/break/user/${userId ? userId : ''}?startDate=${startDate}&endDate=${endDate}`);
    return response;
  }

  public async updateEndTime(breakId: number, endTime: string): Promise<Break> {
    const response = await apiService.put<Break>("/break/update-end-time", {
      breakId,
      endTime
    });
    return response;
  }
}

export default BreakService.getInstance();